module.exports = __webpack_public_path__ + "media/Icosahedron.c0ff606f.mp4";